export interface OnboardingBusinessProfile {
  businessName: string;
}

export interface OnboardingPersonality {
  tone: string;
  primaryLanguage: string;
  additionalLanguages: string[];
}

export interface AgentOnboardingInput {
  profile: OnboardingBusinessProfile;
  personality: OnboardingPersonality;
}

export interface GeneratedAgentDraft {
  name: string;
  description: string;
  context: string;
}

const formatLanguages = (personality: OnboardingPersonality): string => {
  const additional = personality.additionalLanguages.filter(
    language => language !== personality.primaryLanguage
  );
  if (additional.length === 0) {
    return `Primary language: ${personality.primaryLanguage}.`;
  }
  return `Primary language: ${personality.primaryLanguage}. Additional supported languages: ${additional.join(', ')}.`;
};

export const buildAgentDraftFromOnboarding = (
  input: AgentOnboardingInput
): GeneratedAgentDraft => {
  const name = input.profile.businessName.trim() || 'New Dialup Agent';
  const description = [
    `${name} call assistant.`,
    `Tone: ${input.personality.tone}.`,
    'Answers caller questions, gathers details, and routes conversations to the team when needed.',
  ].join(' ');

  const context = [
    `Tone: ${input.personality.tone}.`,
    formatLanguages(input.personality),
  ].join('\n');

  return { name, description, context };
};
